module.exports = __webpack_public_path__ + "img/mac-download1.bbbb97c1.png";